import * as React from 'react';

function SvgBrightnessAltHigh(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8 3a.5.5 0 01.5.5v2a.5.5 0 01-1 0v-2A.5.5 0 018 3zm8 8a.5.5 0 01-.5.5h-2a.5.5 0 010-1h2a.5.5 0 01.5.5zm-13.5.5a.5.5 0 000-1h-2a.5.5 0 000 1h2zm11.157-6.157a.5.5 0 010 .707l-1.414 1.414a.5.5 0 11-.707-.707l1.414-1.414a.5.5 0 01.707 0zm-9.9 2.121a.5.5 0 00.707-.707L3.05 5.343a.5.5 0 10-.707.707l1.414 1.414zM8 7a4 4 0 00-4 4 .5.5 0 00.5.5h7a.5.5 0 00.5-.5 4 4 0 00-4-4zm0 1a3 3 0 012.959 2.5H5.04A3 3 0 018 8z' />
		</svg>
	);
}

export default SvgBrightnessAltHigh;
